t = require('app/scripts/views/internal/teacup-with-helpers')('popover_insertion_menu')

module.exports = ->
  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-open-emoji-selector', { href: '#' }, ->
        t.format 'select-emoji-ellipsis'

    t.li ->
      t.a '.js-open-mention-selector', { href: '#' }, ->
        t.format 'mention-member-ellipsis'

